// Analytics consent is separate from legal acceptance. The legacy cookie banner already
// offered explicit "all" versus "necessary" analytics choices, so those can be preserved.
export const CONSENT_KEY = 'retailmaps:analytics-consent:v1';
export const LEGACY_CONSENT_KEY = 'retailmaps:cookie-consent:v1';
export const CONSENT_MAX_AGE = 180 * 24 * 60 * 60 * 1000;

export function readAnalyticsConsent(storage, now = Date.now()) {
  try {
    const raw = storage.getItem(CONSENT_KEY);
    if (raw) {
      const record = JSON.parse(raw);
      if (record?.version !== 1 || !['granted', 'denied'].includes(record.choice)) return 'unknown';
      if (!Number.isFinite(record.at) || record.at > now || now - record.at >= CONSENT_MAX_AGE) return 'unknown';
      return record.choice;
    }
    const legacy = JSON.parse(storage.getItem(LEGACY_CONSENT_KEY) || 'null');
    if (!Number.isFinite(Date.parse(legacy?.acceptedAt))) return 'unknown';
    if (legacy.cookieLevel === 'all') return 'granted';
    if (legacy.cookieLevel === 'necessary') return 'denied';
    return 'unknown';
  } catch (_) { return 'unknown'; }
}

export function saveAnalyticsConsent(storage, choice, now = Date.now()) {
  if (!['granted', 'denied'].includes(choice)) return false;
  try {
    storage.setItem(CONSENT_KEY, JSON.stringify({ version: 1, choice, at: now }));
    return true;
  } catch (_) { return false; }
}
